import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\UpdatePersonController::__invoke
* @see app/Http/Controllers/Person/UpdatePersonController.php
* @route '/api/person/{person}'
*/
const UpdatePersonController = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePersonController.url(args, options),
    method: 'put',
})

UpdatePersonController.definition = {
    methods: ["put"],
    url: '/api/person/{person}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Person\UpdatePersonController::__invoke
* @see app/Http/Controllers/Person/UpdatePersonController.php
* @route '/api/person/{person}'
*/
UpdatePersonController.url = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return UpdatePersonController.definition.url
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\UpdatePersonController::__invoke
* @see app/Http/Controllers/Person/UpdatePersonController.php
* @route '/api/person/{person}'
*/
UpdatePersonController.put = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePersonController.url(args, options),
    method: 'put',
})

export default UpdatePersonController